import "./GalleryPage.css";

function GalleryPage() {
  return (
    <div className="gallery-page">
      <div className="gallery-page__content">अहिले कुनै गेलरी उपलब्द छैन</div>
    </div>
  );
}

export default GalleryPage;
